import { render, staticRenderFns } from "./HelloMessage.vue?vue&type=template&id=127bdc36&lang=pug"
import script from "./HelloMessage.vue?vue&type=script&lang=ts"
export * from "./HelloMessage.vue?vue&type=script&lang=ts"
import style0 from "./HelloMessage.vue?vue&type=style&index=0&id=127bdc36&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HelloMessage.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FCompliance%2Fcomponents%2FHelloMessage.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports